define('OutSystems/ClientRuntime/ErrorHandling',["require", "exports", "./ApplicationInfo", "./Exceptions", "./Logger", "./Navigation", "./StorageProvider"], function (require, exports, ApplicationInfo, Exceptions, Logger, Navigation, StorageProvider_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isSpecialHandleErrorResult = exports.ignoreError = exports.defaultErrorHandler = exports.handleError = exports.navigateToAppOffline = exports.navigateToIncompatibleProducer = exports.navigateToErrorPage = exports.ErrorHandlingStorage = exports.IGNORED_ERROR_RESULT = exports.UNHANDLED_ERROR_RESULT = exports.ERROR_PAGE_HTML = void 0;
    exports.ERROR_PAGE_HTML = "_error.html";
    exports.UNHANDLED_ERROR_RESULT = { errorCode: "UNHANDLED" };
    exports.IGNORED_ERROR_RESULT = { errorCode: "IGNORED" };
    var ERROR_HANDLING_MODULE_NAME = "ErrorHandling";
    exports.ErrorHandlingStorage = {
        errorPageMessage: new StorageProvider_1.StorageObject(StorageProvider_1.StorageType.Session, "ErrorPageMessage", ""),
        errorPageExtraMessage: new StorageProvider_1.StorageObject(StorageProvider_1.StorageType.Session, "ErrorPageExtraMessage", ""),
        errorPageExceptionInfo: new StorageProvider_1.StorageObject(StorageProvider_1.StorageType.Session, "ErrorPageExceptionInfo", null),
    };
    function navigateToErrorPage(error, message, extraMessage, callContext) {
        if (message === void 0) { message = ""; }
        if (extraMessage === void 0) { extraMessage = ""; }
        if (!Navigation.hasPendingReload()) {
            if (error) {
                Logger.error(null, error);
            }
            if (Navigation.isValidContext(callContext)) {
                var errorScreenLocation = Navigation.VersionedURL.getVersionedUrl(exports.ERROR_PAGE_HTML);
                exports.ErrorHandlingStorage.errorPageMessage.set(message);
                exports.ErrorHandlingStorage.errorPageExtraMessage.set(extraMessage);
                if (error) {
                    exports.ErrorHandlingStorage.errorPageExceptionInfo.set(Exceptions.getExceptionInfo(error));
                }
                else {
                    exports.ErrorHandlingStorage.errorPageExceptionInfo.remove();
                }
                Navigation.changeWindowLocation(errorScreenLocation);
            }
        }
    }
    exports.navigateToErrorPage = navigateToErrorPage;
    function navigateToIncompatibleProducer(error, callContext) {
        var errorPageConfig = ApplicationInfo.getErrorPageConfig();
        var message = errorPageConfig && errorPageConfig.messages && errorPageConfig.messages.incompatibleProducer;
        this.navigateToErrorPage(error, message || error.message, null, callContext);
    }
    exports.navigateToIncompatibleProducer = navigateToIncompatibleProducer;
    function navigateToAppOffline(callContext) {
        var errorPageConfig = ApplicationInfo.getErrorPageConfig();
        var message = errorPageConfig && errorPageConfig.messages && errorPageConfig.messages.appOffline;
        this.navigateToErrorPage(null, message || "This application is temporarily unavailable. Try reloading or contact the administrator.", null, callContext);
    }
    exports.navigateToAppOffline = navigateToAppOffline;
    function handleError(error, callContext) {
        Logger.trace(ERROR_HANDLING_MODULE_NAME, "Error thrown by the application: " + error);
        if (Exceptions.isApplicationOffline(error)) {
            this.navigateToAppOffline(callContext);
        }
        else if (Exceptions.isInstanceOf(error, Exceptions.Exceptions.IncompatibleProducerException)) {
            this.navigateToIncompatibleProducer(error, callContext);
        }
        else {
            this.navigateToErrorPage(error, null, null, callContext);
        }
    }
    exports.handleError = handleError;
    function defaultErrorHandler(error, callContext) {
        Logger.trace("ErrorHandling", Exceptions.getMessage(error));
        if (!this.ignoreError(error, callContext)) {
            this.handleError(error, callContext);
            return exports.UNHANDLED_ERROR_RESULT;
        }
        return exports.IGNORED_ERROR_RESULT;
    }
    exports.defaultErrorHandler = defaultErrorHandler;
    function ignoreError(error, callContext) {
        if (Exceptions.isInstanceOf(error, Exceptions.Exceptions.IgnorableSystemException)) {
            return true;
        }
        if (Exceptions.isApplicationOffline(error)) {
            this.navigateToAppOffline(callContext);
            return true;
        }
        return false;
    }
    exports.ignoreError = ignoreError;
    function isSpecialHandleErrorResult(target) {
        return target === exports.UNHANDLED_ERROR_RESULT || target === exports.IGNORED_ERROR_RESULT;
    }
    exports.isSpecialHandleErrorResult = isSpecialHandleErrorResult;
});
//# sourceMappingURL=ErrorHandling.js.map;
